module.exports = __webpack_public_path__ + "img/de47649039af49649440db64e75d7423-1440.d8e4c9b4.jpg";